import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

/* Shared chrome for the Bill Lens marketing site (Home / Features / Pricing / About).
   Migrated from the Claude Design project. Palette: dark #263019 · olive #607840 ·
   light-olive #a9bf87 · panel #f2f2f2 · cream #DFE4D8 · soft #EFF1EB.
   Fonts: Inter (body) / Lexend Deca (headings). */
export const MK_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Lexend+Deca:wght@400;500&display=swap');

.mk { --dark:#263019; --olive:#607840; --lolive:#a9bf87; --ink:#020202; --muted:#4D4D4D; --panel:#f2f2f2; --cream:#DFE4D8; --soft:#EFF1EB;
  width:100%; overflow-x:hidden; background:#fff; color:var(--ink);
  font-family:"Inter",system-ui,sans-serif; -webkit-font-smoothing:antialiased; }
.mk h1,.mk h2,.mk h3,.mk h4,.mk h5,.mk h6 { font-family:"Lexend Deca",sans-serif; font-weight:400; line-height:1.2; letter-spacing:-0.01em; }
.mk a { color:inherit; text-decoration:none; }
.mk-wrap { max-width:1280px; margin:0 auto; }
.mk-eyebrow { font-weight:600; font-size:16px; }
.mk-eyebrow.head { margin-bottom:16px; }

/* buttons */
.mk-btn { display:inline-flex; align-items:center; justify-content:center; gap:6px; border:none; cursor:pointer;
  border-radius:100px; font-family:inherit; font-weight:500; white-space:nowrap; transition:transform .2s, filter .2s; }
.mk-btn:hover { transform:translateY(-1px); }
.mk-btn.wide { width:100%; }
.mk-btn-sm { padding:8px 20px; font-size:14px; }
.mk-btn-lg { padding:12px 24px; font-size:16px; }
.mk-btn-primary { color:#fff; background:var(--olive);
  box-shadow:inset 0 -2px 1px 0 rgba(2,2,2,.2),inset 0 1px 1px 1px rgba(255,255,255,.2),inset 0 0 0 1px rgba(2,2,2,.15),0 1px 2px 0 rgba(2,2,2,.05); }
.mk-btn-glass { color:#fff; background:rgba(255,255,255,.1); backdrop-filter:blur(10px);
  box-shadow:0 1px 2px 0 rgba(2,2,2,.05),inset 0 -2px 1px 0 rgba(2,2,2,.05),inset 0 0 0 1px rgba(255,255,255,.1); }
.mk-btn-soft { color:var(--ink); background:rgba(2,2,2,.05);
  box-shadow:0 1px 2px 0 rgba(2,2,2,.05),inset 0 -2px 1px 0 rgba(2,2,2,.05),inset 0 0 0 1px rgba(2,2,2,.08); }
.mk-link { display:inline-flex; align-items:center; gap:8px; font-weight:500; cursor:pointer; }

/* sections */
.mk-sec { padding:112px 5%; }
.mk-sec.dark { background:var(--dark); color:#fff; }
.mk-narrow { max-width:768px; margin:0 auto; text-align:center; }
.mk-narrow h1 { margin-bottom:24px; font-size:clamp(42px,7vw,72px); }
.mk-narrow h2 { margin-bottom:24px; font-size:clamp(32px,5vw,52px); }
.mk-narrow > p { font-size:18px; line-height:1.5; max-width:560px; margin:0 auto; }
.mk-cta-row { margin-top:32px; display:flex; align-items:center; justify-content:center; gap:16px; flex-wrap:wrap; }
.mk-center-head { margin:0 auto 80px; max-width:768px; text-align:center; }
.mk-center-head h2 { margin-bottom:24px; font-size:clamp(32px,5vw,52px); }
.mk-center-head p { font-size:18px; line-height:1.5; }
.mk-two { display:grid; grid-template-columns:1fr 1fr; align-items:center; gap:80px; }

/* checklist */
.mk-check { list-style:none; display:flex; flex-direction:column; gap:16px; margin:0; padding:0; }
.mk-check li { display:flex; align-items:flex-start; gap:12px; font-size:16px; line-height:1.5; }
.mk-check .ic { flex:0 0 auto; margin-top:2px; display:inline-flex; align-items:center; justify-content:center;
  width:24px; height:24px; border-radius:50%; background:var(--cream); }

/* image placeholders (source photos unavailable) */
.mk-img { border-radius:8px; overflow:hidden; position:relative; display:grid; place-items:center;
  background:linear-gradient(135deg,#e8f0dc,#c9dbab); }
.mk-img .ph { font-size:12px; letter-spacing:.14em; text-transform:uppercase; color:var(--olive); opacity:.6; text-align:center; padding:8px; }

/* nav */
.mk-nav { position:relative; z-index:10; display:flex; align-items:center; min-height:72px; padding:0 5%; background:var(--dark); color:#fff; }
.mk-nav-inner { display:flex; width:100%; align-items:center; justify-content:space-between; }
.mk-nav-links { display:flex; align-items:center; gap:8px; }
.mk-nav-links a { padding:24px 16px; font-size:16px; cursor:pointer; }
.mk-nav-links a.active { font-weight:600; }
.mk-nav-actions { display:flex; align-items:center; gap:16px; }
.mk-logo { display:flex; align-items:center; background:none; border:none; padding:0; cursor:pointer; }

/* footer */
.mk-foot { padding:80px 5%; background:var(--dark); color:#fff; }
.mk-foot-top { display:flex; align-items:flex-start; justify-content:space-between; flex-wrap:wrap; gap:24px; }
.mk-foot-top h3 { font-family:"Inter",sans-serif; font-size:18px; font-weight:600; }
.mk-foot-top p { font-size:16px; margin-top:4px; }
.mk-news { min-width:300px; max-width:448px; flex:1; }
.mk-news form { display:grid; grid-template-columns:1fr max-content; gap:16px; margin-bottom:12px; }
.mk-news input { border-radius:12px; padding:12px 20px; font-size:16px; font-family:"Inter",sans-serif; color:#fff;
  background:rgba(255,255,255,.05); border:1px solid rgba(255,255,255,.2); outline:none; }
.mk-news input::placeholder { color:rgba(255,255,255,.6); }
.mk-news .fine { font-size:12px; color:rgba(255,255,255,.7); }
.mk-rule { height:1px; width:100%; background:rgba(255,255,255,.2); }
.mk-foot-cols { display:grid; grid-template-columns:repeat(6,1fr); gap:32px; margin:80px 0; }
.mk-foot-cols h4 { margin-bottom:8px; font-family:"Inter",sans-serif; font-weight:600; font-size:16px; }
.mk-foot-cols ul { list-style:none; margin:0; padding:0; }
.mk-foot-cols li { padding:8px 0; font-size:14px; }
.mk-foot-cols a { cursor:pointer; }
.mk-foot-bottom { display:flex; align-items:center; justify-content:space-between; gap:16px; flex-wrap:wrap; padding-top:32px; font-size:14px; }

@media (max-width:900px){
  .mk-nav-links { display:none; }
  .mk-sec { padding:80px 5%; }
  .mk-two { grid-template-columns:1fr; gap:44px; }
  .mk-center-head { margin-bottom:56px; }
  .mk-foot-cols { grid-template-columns:repeat(3,1fr); gap:32px 24px; margin:56px 0; }
}
@media (max-width:560px){
  .mk-nav-actions .mk-btn:first-child { display:none; }
  .mk-foot-cols { grid-template-columns:repeat(2,1fr); }
  .mk-news { min-width:100%; }
  .mk-news form { grid-template-columns:1fr; }
}
`;

export const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="66" height="34" viewBox="0 0 66 34" fill="none" style={{ display: "block" }} aria-hidden="true">
    <path d="M63.6292 16.1329L63.5941 16.168C63.8398 15.501 64.3312 15.2553 64.7524 15.2553C65.3492 15.2553 65.8757 15.7116 65.8757 16.3786C65.8757 16.519 65.8757 16.6945 65.8055 16.9051C64.5769 20.0642 61.9794 21.6789 59.4521 21.9246C58.2937 23.8903 56.3982 25.3295 53.6954 25.3295C49.8342 25.3295 48.1143 22.2756 48.1143 18.941C48.1143 14.8341 50.7118 10.2709 55.0644 10.2709C56.0121 10.2709 56.8195 10.4815 57.4864 10.7623C59.4521 11.4994 60.7158 14.0619 60.7158 16.7998C60.7158 17.6773 60.6456 18.5549 60.4349 19.3973C61.7337 18.941 62.9623 17.8879 63.6292 16.1329ZM56.2929 13.1492V13.1141C55.5207 13.1141 55.0644 14.1321 55.0644 15.3606C55.0644 17.1508 56.0472 18.8006 57.5917 19.3973C57.8374 18.6251 57.9427 17.7475 57.9427 16.7296C57.9427 14.7639 57.346 13.1492 56.2929 13.1492ZM53.7305 22.7671C54.7134 22.7671 55.6962 22.3458 56.4685 21.4683C54.1868 20.4504 52.7477 18.0634 52.7477 15.7818C52.7477 15.0096 52.8881 14.2023 53.0987 13.5002C51.6946 14.6586 50.8873 16.9402 50.8873 18.941C50.8873 21.5385 52.1158 22.7671 53.7305 22.7671Z" fill="white" />
    <path d="M48.6625 16.1332L48.6273 16.1683C48.8731 15.5014 49.2943 15.2206 49.7155 15.2206C50.3122 15.2206 50.9089 15.7471 50.9089 16.414C50.9089 16.5895 50.8738 16.7299 50.8036 16.9055C49.4347 20.2401 47.3988 24.1364 44.1343 26.418L44.0641 27.12C43.678 31.3322 41.5368 34 38.834 34C36.7981 34 35.6046 32.5959 35.6046 30.9461C35.6046 27.9625 38.6585 26.8743 41.5017 25.049C41.5719 24.3119 41.607 23.4695 41.6421 22.5217C40.238 24.0662 38.7287 24.698 37.3948 24.698C34.7271 24.698 32.5508 22.5217 32.5508 19.1871C32.5508 14.0622 35.9205 10.6925 39.6764 10.6925H39.7115C42.2739 10.6925 45.0119 12.0614 45.0119 14.5185C45.0119 15.3259 44.6609 19.7136 44.38 23.1185C46.2755 21.3283 47.8551 18.4148 48.6625 16.1332ZM37.7809 22.1707C39.0797 22.1707 40.8348 21.3634 41.9229 17.3969C42.0984 16.5193 42.2037 15.7471 42.1686 14.8345C41.958 13.8867 41.1507 13.3251 39.9923 13.3251C37.6054 13.3251 35.3238 15.6067 35.3238 19.0818C35.3238 21.1879 36.3067 22.1707 37.7809 22.1707ZM39.1148 31.4375H39.1499C39.887 31.4375 40.6944 30.9461 41.2209 27.787C39.6764 28.6996 38.2372 29.6123 38.2372 30.7004C38.2372 31.1567 38.5883 31.4375 39.1148 31.4375Z" fill="white" />
    <path d="M33.1585 16.1329L33.1234 16.168C33.3691 15.501 33.8605 15.2553 34.2817 15.2553C34.8785 15.2553 35.405 15.7116 35.405 16.3786C35.405 16.519 35.405 16.6945 35.3348 16.9051C34.1062 20.0642 31.5087 21.6789 28.9814 21.9246C27.823 23.8903 25.9276 25.3295 23.2247 25.3295C19.3635 25.3295 17.6436 22.2756 17.6436 18.941C17.6436 14.8341 20.2411 10.2709 24.5937 10.2709C25.5414 10.2709 26.3488 10.4815 27.0157 10.7623C28.9814 11.4994 30.2451 14.0619 30.2451 16.7998C30.2451 17.6773 30.1749 18.5549 29.9642 19.3973C31.263 18.941 32.4916 17.8879 33.1585 16.1329ZM25.8222 13.1492V13.1141C25.05 13.1141 24.5937 14.1321 24.5937 15.3606C24.5937 17.1508 25.5765 18.8006 27.121 19.3973C27.3667 18.6251 27.472 17.7475 27.472 16.7296C27.472 14.7639 26.8753 13.1492 25.8222 13.1492ZM23.2598 22.7671C24.2427 22.7671 25.2255 22.3458 25.9978 21.4683C23.7161 20.4504 22.277 18.0634 22.277 15.7818C22.277 15.0096 22.4174 14.2023 22.628 13.5002C21.2239 14.6586 20.4166 16.9402 20.4166 18.941C20.4166 21.5385 21.6451 22.7671 23.2598 22.7671Z" fill="white" />
    <path d="M19.4308 15.0238C18.9394 15.0238 18.5181 15.2695 18.2373 15.9365C17.3247 18.2532 15.4291 22.1847 13.4985 22.1847C12.2828 22.1847 11.3421 21.9097 10.3915 21.6319C9.42071 21.3481 8.43965 21.0614 7.14498 21.0614C6.68865 21.0614 6.0568 21.1316 5.46006 21.2369C7.25781 18.7854 7.92941 15.8165 8.58018 10.2046C7.35485 10.1266 6.35813 9.90028 5.63162 9.6716C4.85565 16.7891 3.97447 19.5029 0.756351 22.1847C0.335123 22.5357 0.124512 23.0271 0.124512 23.5186C0.124512 24.2908 0.791459 24.9578 1.63392 24.9578C1.91473 24.9578 2.23065 24.8525 2.54657 24.712C4.33679 23.9047 5.42496 23.6941 6.75885 23.6941C7.60708 23.6941 8.62208 23.9366 9.70873 24.1963C10.9605 24.4955 12.3073 24.8174 13.6038 24.8174C16.4471 24.8174 18.3075 22.0443 20.3786 16.6736C20.4839 16.4981 20.519 16.2875 20.519 16.112C20.519 15.445 19.9924 15.0238 19.4308 15.0238Z" fill="white" />
    <path d="M5.80985 8.219C6.44551 8.44091 7.4379 8.69926 8.72459 8.77568L8.9352 8.77558C12.9018 8.77558 15.4993 6.31842 15.4993 3.36982C15.4993 1.4743 14.025 0 11.954 0C9.18091 0 7.25029 1.89552 6.26742 5.65147C5.03884 4.98453 4.19639 3.79105 3.77516 2.28165C3.56454 1.5445 3.10821 1.08817 2.47637 1.08817C1.70412 1.08817 1.21268 1.68491 1.21268 2.49227C1.21268 4.87923 3.07311 7.16088 5.81109 8.21395C5.81067 8.21563 5.81026 8.21732 5.80985 8.219ZM9.14581 6.21311C9.67235 3.79105 10.5148 2.63267 11.6381 2.63267C12.2348 2.63267 12.6209 2.9837 12.6209 3.61554C12.6209 4.77392 11.3924 6.14291 9.14581 6.21311Z" fill="white" fillRule="evenodd" clipRule="evenodd" />
  </svg>
);

export type MkActive = "home" | "features" | "pricing" | "about";

export function useMkNav() {
  const navigate = useNavigate();
  const { session } = useAuth();
  return {
    session,
    goHome: () => navigate("/home"),
    goFeatures: () => navigate("/features"),
    goPricing: () => navigate("/pricing"),
    goAbout: () => navigate("/about"),
    goApp: () => navigate("/"),
    goLogin: () => navigate("/login"),
    goSignup: () => navigate("/signup"),
  };
}

export function MarketingNav({ active }: { active: MkActive }) {
  const nav = useMkNav();
  return (
    <nav className="mk-nav">
      <div className="mk-nav-inner">
        <button className="mk-logo" onClick={nav.goHome} aria-label="Bill Lens home"><Logo /></button>
        <div className="mk-nav-links">
          <a className={active === "home" ? "active" : ""} onClick={nav.goHome}>Home</a>
          <a className={active === "features" ? "active" : ""} onClick={nav.goFeatures}>Features</a>
          <a className={active === "pricing" ? "active" : ""} onClick={nav.goPricing}>Pricing</a>
          <a className={active === "about" ? "active" : ""} onClick={nav.goAbout}>About</a>
        </div>
        <div className="mk-nav-actions">
          {nav.session ? (
            <button className="mk-btn mk-btn-sm mk-btn-primary" onClick={nav.goApp}>Go to app</button>
          ) : (
            <>
              <button className="mk-btn mk-btn-sm mk-btn-glass" onClick={nav.goLogin}>Log in</button>
              <button className="mk-btn mk-btn-sm mk-btn-primary" onClick={nav.goSignup}>Try free</button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

const FOOTER_COLS = [
  { h: "Product", items: ["Home", "Features", "Pricing", "About us", "Contact"] },
  { h: "Solutions", items: ["Invoice capture", "Price tracking", "Menu costing", "Reporting", "Integrations"] },
  { h: "Roles", items: ["Restaurants", "Cafés", "Bars", "Groups", "Finance"] },
  { h: "Resources", items: ["Blog", "Guides", "Webinars", "Support", "API docs"] },
  { h: "Company", items: ["Our story", "Careers", "Press kit", "Legal", "Security"] },
  { h: "Compare", items: ["Bill Lens vs spreadsheets", "Bill Lens vs competitors", "ROI calculator", "Customer stories", "Switch now"] },
];

export function MarketingFooter() {
  const nav = useMkNav();
  return (
    <footer className="mk-foot">
      <div className="mk-wrap">
        <div className="mk-foot-top">
          <div>
            <h3>Join our newsletter</h3>
            <p>Get the latest on invoice tools and cost control.</p>
          </div>
          <div className="mk-news">
            <form onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Enter your email" aria-label="Email" />
              <button type="submit" className="mk-btn mk-btn-sm mk-btn-glass">Subscribe</button>
            </form>
            <p className="fine">By subscribing you agree to our privacy policy</p>
          </div>
        </div>

        <div className="mk-rule" style={{ margin: "80px 0" }} />

        <div className="mk-foot-cols">
          {FOOTER_COLS.map((col) => (
            <div key={col.h}>
              <h4>{col.h}</h4>
              <ul>{col.items.map((it) => <li key={it}><a>{it}</a></li>)}</ul>
            </div>
          ))}
        </div>

        <div className="mk-rule" />
        <div className="mk-foot-bottom">
          <button className="mk-logo" onClick={nav.goHome} aria-label="Bill Lens home"><Logo /></button>
          <p>© 2026 Bill Lens. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

/* Small shared icons */
export const CheckCircleIcon = () => (
  <span className="ic"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 13l4 4L19 7" stroke="#263019" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg></span>
);

export const ArrowRight = ({ color = "#020202" }: { color?: string }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
);
